export default {
  'Atlanta Dream': {
    displayName: 'ATL Dream',
    logoUrl: 'wnba/atlanta_dream.webp',
  },
  'Dallas Wings': {
    displayName: 'DAL Wings',
    logoUrl: 'wnba/dallas_wings.webp',
  },
  'Chicago Sky': {
    displayName: 'CHI Sky',
    logoUrl: 'wnba/chicago_sky.webp',
  },
  'Golden State Valkyries': {
    displayName: 'GOL Valkyries',
    logoUrl: 'wnba/golden_state_valkyries.webp',
  },
  'Connecticut Sun': {
    displayName: 'CON Sun',
    logoUrl: 'wnba/connecticut_sun.webp',
  },
  'Las Vegas Aces': {
    displayName: 'LAS Aces',
    logoUrl: 'wnba/las_vegas_aces.webp',
  },
  'Indiana Fever': {
    displayName: 'IND Fever',
    logoUrl: 'wnba/indiana_fever.webp',
  },
  'Los Angeles Sparks': {
    displayName: 'LA Sparks',
    logoUrl: 'wnba/los_angeles_sparks.webp',
  },
  'Minnesota Lynx': {
    displayName: 'MIN Lynx',
    logoUrl: 'wnba/minnesota_lynx.webp',
  },
  'New York Liberty': {
    displayName: 'NEW Liberty',
    logoUrl: 'wnba/new_york_liberty.webp',
  },
  'Phoenix Mercury': {
    displayName: 'PHO Mercury',
    logoUrl: 'wnba/phoenix_mercury.webp',
  },
  'Portland Fire': {
    displayName: 'POR Fire',
    logoUrl: 'wnba/portland_fire.webp',
  },
  'Seattle Storm': {
    displayName: 'SEA Storm',
    logoUrl: 'wnba/seattle_storm.webp',
  },
  'Team Cooper': {
    displayName: 'Team Cooper',
    logoUrl: 'wnba/team_coop.webp',
  },
  'Team Weatherspoon': {
    displayName: 'Team Weatherspoon',
    logoUrl: 'wnba/team_spoon.webp',
  },
  'Toronto Tempo': {
    displayName: 'TOR Tempo',
    logoUrl: 'wnba/toronto_tempo.webp',
  },
  'Washington Mystics': {
    displayName: 'WAS Mystics',
    logoUrl: 'wnba/washington_mystics.webp',
  },
};
